import React from "react";
import TalentPostCard from "./CardList/TalentPostCard";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { talentPosts } from "../../constants/talent-profile";

const TalentPost = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid container spacing={isMobile ? 1 : 2}>
      {talentPosts.map((post) => (
        <Grid size={isMobile ? 12 : 6} key={post.id}>
          <Box
            sx={{
              padding: isMobile ? "12px" : "16px",
              border: "1px solid var(--neutral-100)",
              borderRadius: "12px",
              backgroundColor: "var(--neutral-50)",
              height: "100%",
            }}
          >
            <TalentPostCard {...post} />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default TalentPost;
